// extracted by mini-css-extract-plugin
module.exports = {"SkeletonGroup":"RenderLoadingReview_SkeletonGroup__qzj_Z","skeletonGroup":"RenderLoadingReview_SkeletonGroup__qzj_Z"};